export const TITLE_LENGTH_ERROR = 'TITLE_LENGTH_ERROR';
export const DESC_LENGTH_ERROR = 'DESC_LENGTH_ERROR';
